export const enum QueryAndSearchParams {
    arianeeAccessToken = 'arianeeAccessToken',
    arianeeAccessTokenLegacy = 'arianeeJWT',

    proofLink = 'proofLink',
}
